import { Component, OnInit } from '@angular/core';
import { ThemeService } from '../../services';

@Component({
  selector: 'app-data-not-found',
  standalone: true,
  template: `
  <div Class="card-body_light">
  <div style="height: 10vh; display:flex; justify-content:center; align-items: center">
    <span Class="title_light">
      Data Not Found
    </span>
  </div>
</div>
  `,
  styles: `
   .card-body_light {
    // background-color: rgb(229, 231, 235);  
  }
  
    .card-body_dark {
        background-color: rgb(34, 34, 34);
    }
  
  .title_light {
    color: black;
    font-weight: bold;
    font-size: 20px;
    }
    
  .title_dark {
    color: white;
  font-weight: bold;
  font-size: 20px;
  }
  `,
})
export class DataNotFoundComponent implements OnInit {

  constructor(public themeService: ThemeService) { }

  ngOnInit() { }

}
